<form #form="ngForm" (submit)="onSubmit(form)" novalidate>

  <div class="container-fluid">
    <div class="container px-0" >
      <div>
        <ng-container>
          <div class="search-row">
            <mat-form-field class="search-field" appearance="fill">
              <input matInput name="queryString" placeholder="{{'generic.buttons.search' | translate}}" [(ngModel)]="modelSearch.queryString" required>
            </mat-form-field>
            <button matButton="filled" color="primary" type="submit" class="search-btn" [disabled]="loading" (click)="onSubmit(form)">{{'generic.buttons.search' | translate}}</button>
          </div>

          @if (loading) {
            <div class="row">
              <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
            </div>
          }

          @if (pubmedResults.articles) {
            <div class="row">
              <mat-table [dataSource]="pubmedResults.articles" style="width: 100%;" class="table-primary">
                <ng-container matColumnDef="ArticleTitle">
                  <mat-header-cell *matHeaderCellDef style="flex: 0 0 70% !important">{{'components.attachment.pubmed-attachment.article-title' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element" style="flex: 0 0 70% !important"><a target="_blank" [href]="element.link">{{element.ArticleTitle}}</a></mat-cell>
                </ng-container>
                <ng-container matColumnDef="Authors">
                  <mat-header-cell *matHeaderCellDef>{{'components.attachment.pubmed-attachment.authors' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-icon aria-hidden="false" matTooltip="{{element.Authors}}">groups</mat-icon>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PubYear">
                  <mat-header-cell *matHeaderCellDef>{{'components.attachment.pubmed-attachment.pubyear' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.PubYear}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element"><button mat-button color="primary" (click)="addAttachment(element)" ><small>{{'generic.buttons.add' | translate}}</small> <mat-icon>add</mat-icon></button></mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            </div>
          }

          @if (pubmedResults.articles) {
            <div class="paginator-wrapper">
              @if (loading) {
                <mat-progress-bar mode="indeterminate" color="primary" class="paginator-loading"></mat-progress-bar>
              }
              <mat-paginator
                class="paginator-rounded"
                [length]="pubmedResults.total_items"
                [pageSize]="10"
                [disabled]="loading"
                (page)="pageChanged($event)"
                >
              </mat-paginator>
            </div>
          }

        </ng-container>
      </div>
    </div>
  </div>
</form>
